import { Component } from '@angular/core';
import { PhrutillsService } from './generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup } from '@angular/forms';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';


const isShowPic:boolean= false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Breeze Registration';
}
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
      // Optional Step: Do some stuff with the url if needed.

      // If you lower it in the optional step 
      // you don't need to use "toLowerCase" 
      // when you pass it down to the next function
      return super.parse(url.toLowerCase()); 
  }
}